import {createAiAssistantContextStore} from './createAiAssistantContextStore';

/**
 * The single app-wide store instance. Producers call `aiAssistantContextStore.patchContext(...)`;
 * the assistant panel calls `aiAssistantContextStore.getContextForSend()` at send-time.
 */
export const aiAssistantContextStore = createAiAssistantContextStore();
